<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>
        <nav app-breadcrumb class="topbar-breadcrumb"></nav>
    </div>

    <div class="topbar-end">
        <ul class="topbar-menu flex items-center gap-2">
            @if (!inSuperAdminSignal()){
            <li>
                <button
                    class="flex items-center gap-2 px-3 py-1.5 rounded-full border border-surface bg-[var(--p-content-background)] hover:bg-emphasis hover:border-surface transition-all cursor-pointer group"
                    (click)="onChangeCourseClick()" pTooltip="Switch Course" tooltipPosition="bottom">

                    <div class="w-6 h-6 rounded-full bg-primary-50 flex items-center justify-center shrink-0">
                        <i class="fa-solid fa-golf-ball-tee text-xs text-primary-600"></i>
                    </div>
                    <span class="text-sm font-semibold text-color max-w-[8rem] sm:max-w-[12rem] truncate">
                        {{ activeCourseNameComputed() || 'Select Course' }}
                    </span>

                    <i class="pi pi-chevron-down text-[10px] text-muted-color group-hover:text-color ml-1"></i>
                </button>
            </li>
            <span class="text-lg font-semibold mx-2 text-muted-color">|</span>

            }

            @if (authService.isSuperAdminComputedSignal() && !inSuperAdminSignal()) {
            <li class="topbar-super-admin">
                <p-button [rounded]="true" [outlined]="true" pTooltip="Super Admin" [showDelay]="500" icon="pi pi-crown"
                    tooltipPosition="left" class="shrink-0" severity="secondary" (onClick)="gotoSuperAdmin()">
                </p-button>
            </li>
            } @else if (inSuperAdminSignal()) {
            <li class="topbar-super-admin-dashboard">
                <p-button [rounded]="true" [outlined]="true" pTooltip="Live Orders" [showDelay]="500"
                    icon="pi pi-home" tooltipPosition="left" class="shrink-0" severity="secondary"
                    (onClick)="gotoLiveOrders()">
                </p-button>
            </li>
            }

            <li class="topbar-profile ml-2">
                <p-avatar [label]="initialsComputed()"
                    [style]="{ 'background-color': 'var(--clubside-green)', color: 'white' }" size="large"
                    class="cursor-pointer hover:opacity-90 transition-opacity" shape="circle"
                    (click)="onProfileButtonClick()" />
            </li>
        </ul>
    </div>
</div>